export default "__VITE_ASSET__R3PTT5Iy__"